/**
 * @generated SignedSource<<81ef9d15910bb2026d3aaebead3ea422>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PuzzmoCurrentUserStateFragment$data = {
  readonly gameSettings: any;
  readonly id: string;
  readonly nakamaLogin: string;
  readonly nakamaPassword: string;
  readonly ownerID: string;
  readonly " $fragmentType": "PuzzmoCurrentUserStateFragment";
};
export type PuzzmoCurrentUserStateFragment$key = {
  readonly " $data"?: PuzzmoCurrentUserStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PuzzmoCurrentUserStateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PuzzmoCurrentUserStateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownerID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nakamaLogin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nakamaPassword",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gameSettings",
      "storageKey": null
    }
  ],
  "type": "UserState",
  "abstractKey": null
};

(node as any).hash = "1dfa09bf7107253f2ff67c0919ba73c2";

export default node;
